import { createApp } from "vue";
import "es6-promise/auto";
import "./assets/styles/app.scss";
import VueSelect from "vue-select";
import DOMPurify from 'dompurify';

import router, { setStoreInstance } from "./router";
import MainLayout from "./components/layouts/MainLayout";
import store from "./store";
import loadSurvey from "./utils/SurveyLoader";
import { getJSONFromUrlParams } from "./utils/URLParser";

import QuestionLayout from "./components/QuestionLayout";
import TooltipElement from "./components/fields/TooltipElement";

// Passer l'instance du store au router pour qu'il puisse vérifier l'origin
setStoreInstance(store);

/* eslint-disable no-new */
const app = createApp({
  template: "<main-layout/>",
  components: {
    MainLayout,
  },
  created() {
    // Initialiser le survey selon l'origin dans l'URL
    // Toujours charger le survey au démarrage pour s'assurer qu'il correspond à l'URL actuelle
    const survey = loadSurvey();
    const urlParams = getJSONFromUrlParams();
    // Sauvegarder l'origin dans le survey pour la vérification ultérieure
    if (urlParams.origin && survey.sections.globals.questions.origin) {
      survey.sections.globals.questions.origin.response = urlParams.origin;
    }
    store.commit("SET_SURVEY", survey);
    
    const codeClient = urlParams.codeClient;
    if (codeClient) {
      store.dispatch("fetchSurvey", codeClient);
    }
  },
  watch: {
    "$store.state.isSurveyCompleted": function (isSurveyCompleted) {
      if (isSurveyCompleted === true) {
        router.push({ name: "Complet" });
      }
    },
  },
});

app.use(router);
app.use(store);

app.mount("#root");

app.component("question-layout", QuestionLayout);
app.component("tooltip-element", TooltipElement);
app.component("v-select", VueSelect);

app.directive('sane-html', (el, binding) => {
  el.innerHTML = DOMPurify.sanitize(binding.value);
});

if (__DEV__) {
  // Remove productionTip
  app.config.productionTip = false;
}

export default app;
